import { useEffect, useMemo } from 'react'

import { debounce } from '../../utils/debounce'
import type { PageLogger } from './createFlowLogger'

export const useDebouncedTypingLogger = (pageLogger: PageLogger, delay = 300) => {
  const debouncedTyping = useMemo(
    () =>
      debounce((text: string) => {
        void pageLogger.typing({ text })
      }, delay),
    [delay, pageLogger],
  )

  useEffect(() => {
    return () => {
      debouncedTyping.clear()
    }
  }, [debouncedTyping])

  return debouncedTyping
}
